import * as WMS from 'leaflet.wms';

// Keep one identify request per service, but render each layer independently.
const IndependentWMSSource = WMS.Source.extend({
    initialize(url, options) {
        this._layerOverlays = new Map();
        WMS.Source.prototype.initialize.call(this, url, options);
    },

    getLayerOverlay(name) {
        if (!this._layerOverlays.has(name)) {
            const overlay = this.createOverlay(false);
            overlay.setParams({ layers: name });
            this._layerOverlays.set(name, overlay);
        }
        return this._layerOverlays.get(name);
    },

    getLayer(name) {
        const layer = WMS.Source.prototype.getLayer.call(this, name);
        const overlay = this.getLayerOverlay(name);
        overlay.setOpacity(this.options.opacity === undefined ? 1 : this.options.opacity);
        layer.setOpacity = opacity => { overlay.setOpacity(opacity); return layer; };
        layer.bringToBack = () => { overlay.bringToBack(); return layer; };
        layer.bringToFront = () => { overlay.bringToFront(); return layer; };
        return layer;
    },

    refreshOverlay() {
        if (!this._map) return;
        Object.keys(this._subLayers).forEach(name => {
            this.getLayerOverlay(name).addTo(this._map);
        });
        this._layerOverlays.forEach((overlay, name) => {
            if (!this._subLayers[name]) overlay.remove();
        });
    },

    onRemove() {
        this._layerOverlays.forEach(overlay => overlay.remove());
    }
});

export default IndependentWMSSource;
